import * as React from "react";

const DraggableIcon = (props) => (
    <i data-fa-symbol="truck" className="fa-solid fa-arrows fa-fw"></i>

);

export default DraggableIcon;
